import { OrganizationResources } from '../../domain/resources/OrganizationResources';
import { OrganizationResourcesDTO } from '../../domain/resources/OrganizationResourcesDTO';
import { SubscriptionMapper } from '../subscription/SubscriptionMapper';
import { ProjectResourcesMapper } from './ProjectResourcesMapper';

export class OrganizationResourcesMapper {
  static toDomain(props: OrganizationResourcesDTO): OrganizationResources {
    const { organization_id, subscription, projects, users } = props;

    const projectResources = projects.map((project) => ProjectResourcesMapper.toDomain(project));

    return OrganizationResources.create({
      organization_id,
      subscription: SubscriptionMapper.toDomain(subscription),
      projects: projectResources,
      users,
    });
  }
}
